


















































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ModalEdit from "@/components/ModalEdit.vue";
import { CMProfile } from "@/models/cm-profile.model";
import { CMPRofileApi, _retrieveToken } from "@/services/api.service";
import { validationMixin } from "vuelidate";
import {
    required,
    email,
    minLength,
    maxLength,
    minValue,
} from "vuelidate/lib/validators";
import {} from "googlemaps";
import { NATIONALITIES_MAP } from "@/models/cm-nationalities.constant";

@Component({
    components: {
        ModalEdit,
    },
    mixins: [validationMixin],
    validations: {
        formData: {
            nationality: { required },
            basedIn: { required },
        },

        jobsData: {
            selectedJobs: { required },
            preferedLocations: { required },
            firstSkill: { required },
            secondSkill: { required },
            fSkillLev: { required },
            sSkillLev: { required },
            basedIn: { required },
        },
    },
})
export default class ProfileContactInfo extends Vue {
    @Prop({ type: Boolean, default: false })
    public authorRequire;

    public get profile(): CMProfile {
        return this.$store.getters.profile;
    }

    public get countries() {
        return NATIONALITIES_MAP;
    }

    public showContactDialog: boolean = false;
    public saving: boolean = false;
    public newJob: boolean = false;
    public contactInfoFilled: boolean = false;
    public tooltipActive: boolean = false;
    public skillsDialog: boolean = false;
    public jobs: any[] = [];
    public saved: boolean = false;
    public skills: any[] = [];
    public skillLevels: any = {};
    public jobsClosable = true;

    public loadingJobsData: boolean = false;
    public get jobsBasedIn() {
        if (this.jobsData.basedIn) {
            return this.jobsData.basedIn;
        }
        return this.profile.basedIn;
    }
    public set jobsBasedIn(val) {
        this.jobsData.basedIn = val;
    }

    public sliderFormatter = (v) => {
        if (v === 70000) return "No limit";
        return `$${("" + v).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
    };

    get selectedJob() {
        return this.jobsData.jobPosition;
    }
    set selectedJob(val) {
        if (val instanceof Object) {
            this.jobsData.jobPosition = "";
        } else {
            this.jobsData.jobPosition = val;
        }
    }

    public jobsData: any = {
        basedIn: "",
        jobPosition: "",
        selectedJobs: [],
        firstSkill: "",
        fSkillLev: "",
        secondSkill: "",
        sSkillLev: "",
        salary: [10000, 65000],
        preferedLocations: [],
        prefered: "",
        errors: "",
    };
    public formData = {
        nationality: "",
        basedIn: "",
        basedInC: "",
        basedInR: "",
        // phone: ''
    };

    private _autocompleteBasedIn;
    private _jobsAutocompleteBasedIn;
    private _jobsAutocompletePreferredLocations;

    public mounted() {
        this.__mapDataToForm();
    }

    public getValidationClass(fieldName, forceInvalid = false) {
        const field = this.$v.formData[fieldName];
        if (field) {
            return {
                "md-invalid": (field.$invalid && field.$dirty) || forceInvalid,
            };
        }
    }

    public closeJobsModal() {
        if (!this.saved) {
            this.newJob = false;
        }
        this.jobsData.errors = "";
    }

    public jobSelected(val) {
        if (!~this.jobsData.selectedJobs.indexOf(val)) {
            this.jobsData.selectedJobs.push(val);
        }
    }

    public handleModalCloseContactInfo() {
        this.showContactDialog = false;
    }

    public checkJobsForm() {
        this.$v.$touch();
        if (this.$v.jobsData.$invalid) {
            this.jobsData.errors =
                "Every field of this form must be filled. Please, check and try again.";
            return;
        }
        this.updateJobsInfo();
    }

    public async updateJobsInfo() {
        try {
            this.jobsClosable = false;
            this.loadingJobsData = true;
            const res = await CMPRofileApi.updateJobsData({
                basedIn: this.jobsBasedIn,
                jobPositions: this.jobsData.selectedJobs,
                jobSkills: [
                    {
                        id: this.jobsData.firstSkill,
                        level: this.jobsData.fSkillLev,
                    },
                    {
                        id: this.jobsData.secondSkill,
                        level: this.jobsData.sSkillLev,
                    },
                ],
                jobLocations: this.jobsData.preferedLocations,
                jobSalaryRange: {
                    min: this.jobsData.salary[0],
                    max:
                        this.jobsData.salary[1] > 65000
                            ? -1
                            : this.jobsData.salary[1],
                },
            });
            this.saved = true;
            this.skillsDialog = false;
            this.updateNewJob();
            this.$store.commit("updateProfile", res);
        } catch (error) {
            this.jobsData.errors =
                "Something went wrong. Please try again later.";
            console.error(error);
        }
        this.loadingJobsData = false;
        this.jobsClosable = true;
    }

    public openModalEditContactInfo() {
        this.showContactDialog = true;
        setTimeout(() => {
            this._autocompleteBasedIn = new google.maps.places.Autocomplete(
                (this.$refs.basedIn as Vue).$el as HTMLInputElement,
                { types: ["(cities)"] }
            );
            this._autocompleteBasedIn.addListener(
                "place_changed",
                this.onBasedInChange
            );
        }, 200);
    }

    public async updateNewJob() {
        try {
            await CMPRofileApi.updateLookingForJob(this.newJob);
        } catch (e) {
            console.error(e);
        }
    }

    public newJobSwitch() {
        if (this.newJob) {
            this.skillsDialog = true;
            this.saved = false;
        } else {
            this.updateNewJob();
        }
    }

    public async updateContactInfo() {
        this.$v.$touch();
        if (this.$v.formData.$invalid) {
            return;
        }
        this.saving = true;
        this.__mapFormToProfile();
        try {
            await CMPRofileApi.updateContantInfo({
                nationality: this.profile.nationality,
                basedIn: this.profile.basedIn,
                basedInC: this.profile.basedInC,
                basedInR: this.profile.basedInR,
            });
            this.$store.commit("updateProfile", this.profile);
            this.showContactDialog = false;
        } catch (e) {
            console.error(e);
        } finally {
            this.saving = false;
        }
    }

    @Watch("skillsDialog")
    public async onSkillsDialogChange(val) {
        if (val) {
            this.jobsData.basedIn = this.profile.basedIn;
            this.loadingJobsData = true;
            this.skillLevels = this.$store.getters.conf.job_skill_levels;
            try {
                this.jobs = await CMPRofileApi.getJobPositionsList(true);
                this.skills = await CMPRofileApi.getJobSkillsList();
            } catch (error) {
                console.error(error);
            }
            this.jobsData.selectedJobs = this.jobsData.selectedJobs.map(
                (el) => {
                    return this.jobs.find((job) => job.id === el.id);
                }
            );
            this.loadingJobsData = false;
            setTimeout(() => {
                this._jobsAutocompleteBasedIn = new google.maps.places.Autocomplete(
                    (this.$refs.jobsBasedIn as Vue).$el as HTMLInputElement,
                    { types: ["(cities)"] }
                );
                this._jobsAutocompleteBasedIn.addListener(
                    "place_changed",
                    this.onJobsBasedInChange
                );

                this._jobsAutocompletePreferredLocations = new google.maps.places.Autocomplete(
                    (this.$refs.preferedLocation as Vue)
                        .$el as HTMLInputElement,
                    { types: ["(cities)"] }
                );
                this._jobsAutocompletePreferredLocations.addListener(
                    "place_changed",
                    this.onJobsPreferredLocationsChange
                );
            }, 200);
        }
    }

    public txtOnOff(): string {
        return this.newJob ? "Yes" : "No";
    }

    @Watch("profile", { deep: true })
    public onProfileChange(val: CMProfile, oldVal: CMProfile) {
        if (!this.skillsDialog) {
            this.__mapDataToForm();
        }
    }

    private __mapDataToForm() {
        if (this.profile) {
            this.newJob = this.profile.lookingForJob;
            this.formData.nationality = this.profile.nationality || "";
            this.formData.basedIn = this.profile.basedIn || "";
            this.formData.basedInC = this.profile.basedInC || "";
            this.formData.basedInR = this.profile.basedInR || "";
            if (this.profile.nationality && this.profile.nationality !== "") {
                this.contactInfoFilled = true;
            }
            if (this.profile.jobData.jobPositions.length > 0) {
                this.jobsData.selectedJobs = this.profile.jobData.jobPositions;
                this.jobsData.preferedLocations = this.profile.jobData.jobLocations;
                this.jobsData.firstSkill = this.profile.jobData.jobSkills[0].jobSkill.id;
                this.jobsData.secondSkill = this.profile.jobData.jobSkills[1].jobSkill.id;
                this.jobsData.fSkillLev = this.profile.jobData.jobSkills[0].level;
                this.jobsData.sSkillLev = this.profile.jobData.jobSkills[1].level;
                this.jobsData.salary = [
                    this.profile.jobData.jobSalaryRange.min,
                    this.profile.jobData.jobSalaryRange.max === -1
                        ? 70000
                        : this.profile.jobData.jobSalaryRange.max,
                ];
            }
        }
    }

    private __mapFormToProfile() {
        this.profile.lookingForJob = this.newJob;
        this.profile.nationality = this.formData.nationality;
        this.profile.basedIn = this.formData.basedIn;
        this.profile.basedInC = this.formData.basedInC;
        this.profile.basedInR = this.formData.basedInR;
    }

    private onBasedInChange() {
        const place = this._autocompleteBasedIn.getPlace();
        const ac = place.address_components;
        this.formData.basedIn = place.formatted_address;

        ac.forEach((el) => {
            if (el.types.includes("country")) {
                this.formData.basedInC = el.short_name;
                return;
            }
            if (el.types.includes("political")) {
                this.formData.basedInR = el.long_name;
                return;
            }
        });
    }

    private onJobsPreferredLocationsChange() {
        const gObj = this._jobsAutocompletePreferredLocations.getPlace();
        let exists = false;
        let country;
        gObj.address_components.forEach(
            (el) => el.types.includes("country") && (country = el.short_name)
        );
        this.jobsData.preferedLocations.forEach((el) => {
            if (el.name === gObj.name && el.country === country) {
                exists = true;
            }
        });
        if (!exists) {
            this.jobsData.preferedLocations.push({
                name: gObj.name,
                country: country,
                lat: gObj.geometry.location.lat(),
                lng: gObj.geometry.location.lng(),
            });
        }

        this.jobsData.prefered = "";
    }

    private onJobsBasedInChange() {
        this.jobsBasedIn = this._jobsAutocompleteBasedIn.getPlace().formatted_address;
        this.jobsData.basedIn = this.jobsBasedIn;
    }
}
